import * as actionTypes from './actionTypes';

export const mapReligionNextStep = () => {
  return {
    type : actionTypes.MAP_RELIGION_NEXT_STEP,
    val : null
  }
}

export const mapReligionGoBack = () => {
  return {
    type : actionTypes.MAP_RELIGION_PREVIOUS_STEP,
    val : null
  }
}

export const mapReligionUploadFileSuccess = (columns, data, file) => {
  console.log(columns, data, file)
  return {
    type : actionTypes.MAP_RELIGION_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapReligionMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_RELIGION_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllReligionMapping = (val) => {
  return {
    type : actionTypes.MAP_RELIGION_SAVE_RELIGION_MAPPING,
    val : val
  }
}

export const resetReligion = () => {
  return {
    type : actionTypes.MAP_RELIGION_RESET,
    val : null
  }
}

export const resetMapReligionStep = () => {
  return {
    type : actionTypes.MAP_RELIGION_RESET_STEP,
    val : null
  }
}
